import { getBillingPending } from '@/api/brandBilling'

function unwrapList (res) {
  const body = (res && res.data) != null ? res.data : res
  return Array.isArray(body) ? body : []
}

const state = {
  pendingItems: [],
  loading: false,
  lastRefreshAt: ''
}

const mutations = {
  SET_BILLING_CART (state, payload) {
    state.pendingItems = (payload && payload.pendingItems) || []
    state.lastRefreshAt = (payload && payload.lastRefreshAt) || ''
  },
  SET_BILLING_CART_LOADING (state, v) {
    state.loading = !!v
  }
}

const getters = {
  cartItems (state) {
    return state.pendingItems || []
  },
  cartCount (state, getters) {
    return (getters.cartItems || []).length
  },
  loading (state) {
    return state.loading
  }
}

const actions = {
  async refresh ({ commit }) {
    commit('SET_BILLING_CART_LOADING', true)
    try {
      const res = await getBillingPending().catch(function () { return { data: [] } })
      const pendingItems = unwrapList(res)
      commit('SET_BILLING_CART', {
        pendingItems: pendingItems,
        lastRefreshAt: new Date().toISOString()
      })
      return pendingItems
    } finally {
      commit('SET_BILLING_CART_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/store/modules/billingAddonGuide.js